export const processKitFrameColumns = [
    {
        header: 'COLLECTION',
        accessorKey: 'Collection',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'MODEL',
        accessorKey: 'Model',
        size: 30,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'COLOR',
        accessorKey: 'Color',
        size: 30,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'COLOR DESCRIPTION',
        accessorKey: 'ColorDescription',
        size: 70,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'EYE SIZE',
        accessorKey: 'EyeSize',
        size: 30,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'UPCCODE',
        accessorKey: 'UPC',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'FRAME TYPE',
        accessorKey: 'FrameType',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'MED COST',
        accessorKey: 'MEDCost',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'QUANTITY',
        accessorKey: 'Quantity',
        size: 30,
        enableColumnFilter: false,
        enableSorting: false,
    }
];

export const processKitOfficesColumns = [
    {
        header: 'LOCATIONNUMBER',
        accessorKey: 'LocationNumber',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'QUANTITY',
        accessorKey: 'Quantity',
        size: 30,
        enableColumnFilter: false,
        enableSorting: false,
    }
];